export default `/* stylelint-disable no-invalid-position-declaration */
.hide {
  display: none;
}

@media all and (max-width: 2463px) {
  .hide-xxl-down {
    display: none;
  }
}

@media all and (min-width: 2463px) {
  .hide-xxl-up {
    display: none;
  }
}

@media all and (max-width: 1183px) {
  .hide-xl-down {
    display: none;
  }
}

@media all and (min-width: 1183px) {
  .hide-xl-up {
    display: none;
  }
}

@media all and (max-width: 928px) {
  .hide-lg-down {
    display: none;
  }
}

@media all and (min-width: 928px) {
  .hide-lg-up {
    display: none;
  }
}

@media all and (max-width: 927px) {
  .hide-md-down {
    display: none;
  }
}

@media all and (min-width: 927px) {
  .hide-md-up {
    display: none;
  }
}

@media all and (max-width: 767px) {
  .hide-sm-down {
    display: none;
  }
}

@media all and (min-width: 767px) {
  .hide-sm-up {
    display: none;
  }
}

@media all and (max-width: 320px) {
  .hide-xs-down {
    display: none;
  }
}

@media all and (min-width: 320px) {
  .hide-xs-up {
    display: none;
  }
}

:host {
  display: block;
}

:host([hidden]) {
  display: none;
}

.ids-time-picker {
  display: inline-block;
  max-width: 100%;
}
.ids-time-picker ids-trigger-field,
.ids-time-picker .ids-trigger-field {
  display: inline-block;
  max-width: 100%;
}
.ids-time-picker ids-trigger-field[size=full] {
  display: block;
}
.ids-time-picker.full {
  display: block;
}
.ids-time-picker.full ids-trigger-field,
.ids-time-picker.full .ids-trigger-field {
  display: block;
}
.ids-time-picker ids-dropdown::part(trigger-field) {
  display: inline-flex;
  min-width: 75px;
}
.ids-time-picker ids-list-box,
.ids-time-picker ids-list-box-option {
  width: 100%;
}
.ids-time-picker ids-popup::part(popup) {
  margin: var(--ids-space-none);
  padding: var(--ids-space-none);
}
.ids-time-picker .dropdowns {
  display: flex;
  flex-direction: row;
  padding-inline-start: 15px;
  padding-inline-end: 15px;
  padding-top: 15px;
}
.ids-time-picker .ids-button-group {
  width: 100%;
  box-sizing: border-box;
  margin: 0;
}
.ids-time-picker .ids-button-group .ids-button-group-section {
  display: flex;
  justify-content: center;
  flex: 1;
}
.ids-time-picker .ids-button-group .ids-button-group-section .ids-button {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
}
.ids-time-picker .dropdown::part(trigger-field) {
  justify-content: center;
}
.ids-time-picker.is-open ids-trigger-button::part(button) {
  color: var(--ids-time-picker-button-color-background-expanded);
}
.ids-time-picker.is-open ids-trigger-field::part(field-container) {
  border-color: var(--ids-time-picker-input-color-border-expanded);
}
@media all and (max-width: 320px) {
  .ids-time-picker .dropdowns {
    flex-direction: column;
    align-items: center;
    width: var(--ids-input-width-10);
  }
  .ids-time-picker .separator {
    display: none;
  }
}
.ids-time-picker.color-variant-borderless ids-trigger-field::part(input) {
  padding-inline-end: 0 !important;
}
.ids-time-picker.color-variant-borderless.field-height-lg ids-trigger-field::part(input) {
  padding-inline: 14px;
  height: 50px;
}
.ids-time-picker.color-variant-borderless.field-height-md ids-trigger-field::part(input) {
  padding-inline: 10px;
  height: 40px;
}
.ids-time-picker.color-variant-borderless.field-height-sm ids-trigger-field::part(input) {
  padding-inline: 6px;
  height: 35px;
}
.ids-time-picker.color-variant-borderless.field-height-xs ids-trigger-field::part(input) {
  padding-inline: 2px;
  height: 30px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2J1aWxkcy9pbmZvci1kZXNpZ24vZW50ZXJwcmlzZS13Yy9zcmMvY29tcG9uZW50cy9pZHMtdGltZS1waWNrZXIiLCJzb3VyY2VzIjpbIi4uLy4uL3RoZW1lcy9taXhpbnMvaWRzLWhpZGUtbWl4aW4uc2NzcyIsImlkcy10aW1lLXBpY2tlci5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0FBSUE7RUFDRTs7O0FBSUE7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FBV0Y7RUFERjtJQUVJOzs7O0FDNUlKO0VBQ0U7OztBQUdGO0VBQ0U7OztBQUdGO0VBQ0U7RUFDQTs7QUFHQTtBQUFBO0VBRUU7RUFDQTs7QUFJQTtFQUNFOztBQUlKO0VBQ0U7O0FBRUE7QUFBQTtFQUVFOztBQUtGO0VBQ0U7RUFDQTs7QUFJSjtBQUFBO0VBRUU7O0FBSUE7RUFDRTtFQUNBOztBQUlKO0VBQ0U7RUFDQTtFQUNBO0VBQ0E7RUFDQTs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTs7QUFFQTtFQUNFO0VBQ0E7RUFDQTtFQUNBOztBQUtOO0VBQ0U7O0FBS0E7RUFDRTs7QUFHRjtFQUNFOztBRDRESjtFQ3ZERTtJQUNFO0lBQ0E7SUFDQTs7RUFHRjtJQUNFOzs7QUFNRjtFQUNFOztBQUlBO0VBQ0U7RUFDQTs7QUFLRjtFQUNFO0VBQ0E7O0FBS0Y7RUFDRTtFQUNBOztBQUtGO0VBQ0U7RUFDQSIsInNvdXJjZXNDb250ZW50IjpbIi8qIHN0eWxlbGludC1kaXNhYmxlIG5vLWludmFsaWQtcG9zaXRpb24tZGVjbGFyYXRpb24gKi9cbkB1c2UgJy4uLy4uL3RoZW1lcy9taXhpbnMvaWRzLWNvcmUtbWl4aW5zJyBhcyAqO1xuXG4vLyBJbmNsdWRlcyBIaWRkZW4gQ2xhc3NlcyBhbmQgTWl4aW5zIGZvciBoaWRpbmcgZWxlbWVudHMgYXQgYnJlYWtwb2ludHNcbi5oaWRlIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuLmhpZGUteHhsLWRvd24ge1xuICBAbWVkaWEgYWxsIGFuZCAobWF4LXdpZHRoOiAkYnJlYWtwb2ludC14eGwpIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbkBtaXhpbiBoaWRlLXh4bC1kb3duIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1heC13aWR0aDogJGJyZWFrcG9pbnQteHhsKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG4uaGlkZS14eGwtdXAge1xuICBAbWVkaWEgYWxsIGFuZCAobWluLXdpZHRoOiAkYnJlYWtwb2ludC14eGwpIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbkBtaXhpbiBoaWRlLXh4bC11cCB7XG4gIEBtZWRpYSBhbGwgYW5kIChtaW4td2lkdGg6ICRicmVha3BvaW50LXh4bCkge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuLmhpZGUteGwtZG93biB7XG4gIEBtZWRpYSBhbGwgYW5kIChtYXgtd2lkdGg6ICRicmVha3BvaW50LXhsKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG5AbWl4aW4gaGlkZS14bC1kb3duIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1heC13aWR0aDogJGJyZWFrcG9pbnQteGwpIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi5oaWRlLXhsLXVwIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1pbi13aWR0aDogJGJyZWFrcG9pbnQteGwpIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbkBtaXhpbiBoaWRlLXhsLXVwIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1pbi13aWR0aDogJGJyZWFrcG9pbnQteGwpIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi5oaWRlLWxnLWRvd24ge1xuICBAbWVkaWEgYWxsIGFuZCAobWF4LXdpZHRoOiAkYnJlYWtwb2ludC1sZykge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuQG1peGluIGhpZGUtbGctZG93biB7XG4gIEBtZWRpYSBhbGwgYW5kIChtYXgtd2lkdGg6ICRicmVha3BvaW50LWxnKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG4uaGlkZS1sZy11cCB7XG4gIEBtZWRpYSBhbGwgYW5kIChtaW4td2lkdGg6ICRicmVha3BvaW50LWxnKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG5AbWl4aW4gaGlkZS1sZy11cCB7XG4gIEBtZWRpYSBhbGwgYW5kIChtaW4td2lkdGg6ICRicmVha3BvaW50LWxnKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG4uaGlkZS1tZC1kb3duIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1heC13aWR0aDogJGJyZWFrcG9pbnQtbWQpIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbkBtaXhpbiBoaWRlLW1kLWRvd24ge1xuICBAbWVkaWEgYWxsIGFuZCAobWF4LXdpZHRoOiAkYnJlYWtwb2ludC1tZCkge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuLmhpZGUtbWQtdXAge1xuICBAbWVkaWEgYWxsIGFuZCAobWluLXdpZHRoOiAkYnJlYWtwb2ludC1tZCkge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuQG1peGluIGhpZGUtbWQtdXAge1xuICBAbWVkaWEgYWxsIGFuZCAobWluLXdpZHRoOiAkYnJlYWtwb2ludC1tZCkge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuLmhpZGUtc20tZG93biB7XG4gIEBtZWRpYSBhbGwgYW5kIChtYXgtd2lkdGg6ICRicmVha3BvaW50LXNtKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG5AbWl4aW4gaGlkZS1zbS1kb3duIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1heC13aWR0aDogJGJyZWFrcG9pbnQtc20pIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi5oaWRlLXNtLXVwIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1pbi13aWR0aDogJGJyZWFrcG9pbnQtc20pIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbkBtaXhpbiBoaWRlLXNtLXVwIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1pbi13aWR0aDogJGJyZWFrcG9pbnQtc20pIHtcbiAgICBkaXNwbGF5OiBub25lO1xuICB9XG59XG5cbi5oaWRlLXhzLWRvd24ge1xuICBAbWVkaWEgYWxsIGFuZCAobWF4LXdpZHRoOiAkYnJlYWtwb2ludC14cykge1xuICAgIGRpc3BsYXk6IG5vbmU7XG4gIH1cbn1cblxuQG1peGluIGhpZGUteHMtZG93biB7XG4gIEBtZWRpYSBhbGwgYW5kIChtYXgtd2lkdGg6ICRicmVha3BvaW50LXhzKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG4uaGlkZS14cy11cCB7XG4gIEBtZWRpYSBhbGwgYW5kIChtaW4td2lkdGg6ICRicmVha3BvaW50LXhzKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG5AbWl4aW4gaGlkZS14cy11cCB7XG4gIEBtZWRpYSBhbGwgYW5kIChtaW4td2lkdGg6ICRicmVha3BvaW50LXhzKSB7XG4gICAgZGlzcGxheTogbm9uZTtcbiAgfVxufVxuXG5AbWl4aW4gYnJlYWtwb2ludC14cy1kb3duIHtcbiAgQG1lZGlhIGFsbCBhbmQgKG1heC13aWR0aDogJGJyZWFrcG9pbnQteHMpIHtcbiAgICBAY29udGVudDtcbiAgfVxufVxuIiwiQHVzZSAnLi4vLi4vdGhlbWVzL21peGlucy9pZHMtaGlkZS1taXhpbicgYXMgKjtcblxuOmhvc3Qge1xuICBkaXNwbGF5OiBibG9jaztcbn1cblxuOmhvc3QoW2hpZGRlbl0pIHtcbiAgZGlzcGxheTogbm9uZTtcbn1cblxuLmlkcy10aW1lLXBpY2tlciB7XG4gIGRpc3BsYXk6IGlubGluZS1ibG9jaztcbiAgbWF4LXdpZHRoOiAxMDAlO1xuXG4gIC8vIEZpeGVzIGlucHV0IGRvZXNuJ3Qgc3RyZXRjaCB0byBsZyBzaXplIGFuZCB1cFxuICBpZHMtdHJpZ2dlci1maWVsZCxcbiAgLmlkcy10cmlnZ2VyLWZpZWxkIHtcbiAgICBkaXNwbGF5OiBpbmxpbmUtYmxvY2s7XG4gICAgbWF4LXdpZHRoOiAxMDAlO1xuICB9XG5cbiAgaWRzLXRyaWdnZXItZmllbGQge1xuICAgICZbc2l6ZT0nZnVsbCddIHtcbiAgICAgIGRpc3BsYXk6IGJsb2NrO1xuICAgIH1cbiAgfVxuXG4gICYuZnVsbCB7XG4gICAgZGlzcGxheTogYmxvY2s7XG5cbiAgICBpZHMtdHJpZ2dlci1maWVsZCxcbiAgICAuaWRzLXRyaWdnZXItZmllbGQge1xuICAgICAgZGlzcGxheTogYmxvY2s7XG4gICAgfVxuICB9XG5cbiAgaWRzLWRyb3Bkb3duIHtcbiAgICAmOjpwYXJ0KHRyaWdnZXItZmllbGQpIHtcbiAgICAgIGRpc3BsYXk6IGlubGluZS1mbGV4O1xuICAgICAgbWluLXdpZHRoOiA3NXB4O1xuICAgIH1cbiAgfVxuXG4gIGlkcy1saXN0LWJveCxcbiAgaWRzLWxpc3QtYm94LW9wdGlvbiB7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cblxuICBpZHMtcG9wdXAge1xuICAgICY6OnBhcnQocG9wdXApIHtcbiAgICAgIG1hcmdpbjogdmFyKC0taWRzLXNwYWNlLW5vbmUpO1xuICAgICAgcGFkZGluZzogdmFyKC0taWRzLXNwYWNlLW5vbmUpO1xuICAgIH1cbiAgfVxuXG4gIC5kcm9wZG93bnMge1xuICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICBwYWRkaW5nLWlubGluZS1zdGFydDogMTVweDtcbiAgICBwYWRkaW5nLWlubGluZS1lbmQ6IDE1cHg7XG4gICAgcGFkZGluZy10b3A6IDE1cHg7XG4gIH1cblxuICAuaWRzLWJ1dHRvbi1ncm91cCB7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgYm94LXNpemluZzogYm9yZGVyLWJveDtcbiAgICBtYXJnaW46IDA7XG5cbiAgICAuaWRzLWJ1dHRvbi1ncm91cC1zZWN0aW9uIHtcbiAgICAgIGRpc3BsYXk6IGZsZXg7XG4gICAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgICAgIGZsZXg6IDE7XG5cbiAgICAgIC5pZHMtYnV0dG9uIHtcbiAgICAgICAgd2lkdGg6IDEwMCU7XG4gICAgICAgIHRleHQtYWxpZ246IGNlbnRlcjtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG4gICAgICB9XG4gICAgfVxuICB9XG5cbiAgLmRyb3Bkb3duOjpwYXJ0KHRyaWdnZXItZmllbGQpIHtcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IGNlbnRlcjtcbiAgfVxuXG4gIC8vIElzIG9wZW4gc3RhdGVcbiAgJi5pcy1vcGVuIHtcbiAgICBpZHMtdHJpZ2dlci1idXR0b246OnBhcnQoYnV0dG9uKSB7XG4gICAgICBjb2xvcjogdmFyKC0taWRzLXRpbWUtcGlja2VyLWJ1dHRvbi1jb2xvci1iYWNrZ3JvdW5kLWV4cGFuZGVkKTtcbiAgICB9XG5cbiAgICBpZHMtdHJpZ2dlci1maWVsZDo6cGFydChmaWVsZC1jb250YWluZXIpIHtcbiAgICAgIGJvcmRlci1jb2xvcjogdmFyKC0taWRzLXRpbWUtcGlja2VyLWlucHV0LWNvbG9yLWJvcmRlci1leHBhbmRlZCk7XG4gICAgfVxuICB9XG5cbiAgQGluY2x1ZGUgYnJlYWtwb2ludC14cy1kb3duIHtcbiAgICAuZHJvcGRvd25zIHtcbiAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICBhbGlnbi1pdGVtczogY2VudGVyO1xuICAgICAgd2lkdGg6IHZhcigtLWlkcy1pbnB1dC13aWR0aC0xMCk7XG4gICAgfVxuXG4gICAgLnNlcGFyYXRvciB7XG4gICAgICBkaXNwbGF5OiBub25lO1xuICAgIH1cbiAgfVxuXG4gIC8vIFRpbWUgUGlja2VyIEVkaXRvciBCb3JkZXJsZXNzXG4gICYuY29sb3ItdmFyaWFudC1ib3JkZXJsZXNzIHtcbiAgICBpZHMtdHJpZ2dlci1maWVsZDo6cGFydChpbnB1dCkge1xuICAgICAgcGFkZGluZy1pbmxpbmUtZW5kOiAwICFpbXBvcnRhbnQ7XG4gICAgfVxuXG4gICAgJi5maWVsZC1oZWlnaHQtbGcge1xuICAgICAgaWRzLXRyaWdnZXItZmllbGQ6OnBhcnQoaW5wdXQpIHtcbiAgICAgICAgcGFkZGluZy1pbmxpbmU6IDE0cHg7XG4gICAgICAgIGhlaWdodDogNTBweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLmZpZWxkLWhlaWdodC1tZCB7XG4gICAgICBpZHMtdHJpZ2dlci1maWVsZDo6cGFydChpbnB1dCkge1xuICAgICAgICBwYWRkaW5nLWlubGluZTogMTBweDtcbiAgICAgICAgaGVpZ2h0OiA0MHB4O1xuICAgICAgfVxuICAgIH1cblxuICAgICYuZmllbGQtaGVpZ2h0LXNtIHtcbiAgICAgIGlkcy10cmlnZ2VyLWZpZWxkOjpwYXJ0KGlucHV0KSB7XG4gICAgICAgIHBhZGRpbmctaW5saW5lOiA2cHg7XG4gICAgICAgIGhlaWdodDogMzVweDtcbiAgICAgIH1cbiAgICB9XG5cbiAgICAmLmZpZWxkLWhlaWdodC14cyB7XG4gICAgICBpZHMtdHJpZ2dlci1maWVsZDo6cGFydChpbnB1dCkge1xuICAgICAgICBwYWRkaW5nLWlubGluZTogMnB4O1xuICAgICAgICBoZWlnaHQ6IDMwcHg7XG4gICAgICB9XG4gICAgfVxuICB9XG59XG4iXX0= */`;
